import { Flex } from "antd";
import { FC } from "react";

interface EmptySectionProps {
  title: string;
  description: string;
  icon: JSX.Element;
  secondTitle?: string;
  mini?: boolean;
  paddingX?: string;
  paddingY?: string;
  minHeight?: string;
}

const EmptySection: FC<EmptySectionProps> = ({
  title,
  description,
  icon,
  secondTitle,
  minHeight,
  paddingX = "16px",
  paddingY = "16px",
}) => {
  return (
    <Flex
      align="center"
      justify={"center"}
      vertical
      gap={12}
      className={`my-2 bg-white px-[${paddingX}] py-[${paddingY}] rounded-lg shadow ${
        minHeight && `!min-h-[300px]`
      }`}
      style={{ border: "1px solid #E5E5E5" }}
    >
      {secondTitle ? (
        <p className="my-2 text-[#75757E]">{secondTitle}</p>
      ) : null}
      <div className="max-w-[190px] text-center space-y-3">
        <p className="text-[#75757E]">{icon}</p>
        <h2 className="text-[22px]  font-normal">{title}</h2>
        <p className="text-[#75757E]">{description}</p>
      </div>
    </Flex>
  );
};

export default EmptySection;
